import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LibDocumentationComponent } from '@pishgamrayan/ng-api-documentation';
import { AppIntroService } from 'src/app/layout/components/app-intro/app-intro.service';

@Component({
  selector: 'documentation',
  standalone: true,
  templateUrl: './documentation.component.html',
  imports: [LibDocumentationComponent],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DocumentationComponent {
  //#region properties

  //#endregion

  constructor(private appIntroService: AppIntroService) {
    this.appIntroService.destroy();
  }

}
